export default __webpack_public_path__ + "static/media/arrow.green-r.4692d85c.svg";